import React, { useEffect, useState } from "react";
import { API } from "../../API";
import BranchTable from "../tables/branch/BranchTable";
import AddBranchModel from "../models/branch/AddBranchModel";
import { FaPlus } from "react-icons/fa";
import CountryTable from "../tables/country/CountryTable";
import AddCountryModel from "../models/country/AddCountryModel";

const SuperAdminCountry = () => {
  const [addCountryPopupShow, setAddCountryPopupShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("ALL");
  const [branch, setBranch] = useState([]);
  const [filterArray, setFilterArray] = useState([]);

  const getAllBranch = async () => {
    try {
      const { data } = await API.get("/branch/get");
      setBranch(data.data.branch);
    } catch (error) {
      console.log("error in getAllBranch :", error);
    }
  };

  useEffect(() => {
    getAllBranch();
  }, []);

  const getAllCountry = async () => {
    try {
      setIsLoading(true);
      const { data } = await API.get(`/country/by-branch/${selectedBranch}`);
      setFilterArray(data.data.countries);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error in getAllCountry :", error);
    }
  };

  useEffect(() => {
    getAllCountry();
  }, [selectedBranch]);
  return (
    <div className="p-4">
      <div className="flex justify-between items-center">
        <div className="w-[25%]">
          <select
            id="small"
            onChange={(e) => setSelectedBranch(e.target.value)}
            class="w-full h-10 p-1 text-lg border border-gray-300 rounded-lg bg-gray-50 focus:border-2 focus:border-primary"
          >
            <option
              className={`text-lg h-10 ${
                "ALL" == selectedBranch ? "bg-primary text-white" : ""
              }`}
              value="ALL"
            >
              All
            </option>
            {branch &&
              branch.map((b, i) => (
                <option
                  key={i}
                  className={`text-lg h-10 ${
                    b?._id == selectedBranch ? "bg-primary text-white" : ""
                  }`}
                  value={b?._id}
                >
                  {b?.name}
                </option>
              ))}
          </select>
        </div>
        <div
          onClick={() => setAddCountryPopupShow(true)}
          class="flex items-center text-white gap-2 bg-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center cursor-pointer"
          href={"/product/add"}
        >
          <FaPlus /> Add Country
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <div class="w-16 h-16 border-8 border-dashed rounded-full animate-spin border-primary"></div>
        </div>
      ) : filterArray.length > 0 ? (
        <CountryTable data={filterArray} reload={getAllCountry} />
      ) : (
        <div className="flex justify-center items-center h-[50vh]">
          <div class="text-xl">Data Not Found.</div>
        </div>
      )}
      <AddCountryModel
        show={addCountryPopupShow}
        close={setAddCountryPopupShow}
        reload={getAllCountry}
      />
    </div>
  );
};

export default SuperAdminCountry;
